import { get } from '../utils/request';

export const getLiteData = function (parameter) {
  return get('/api/v1/PreConfig', {}, { params: parameter });
};

export const getLiteCartData = function (cartQueryRequest) {
  return get('/api/v1/PreConfigCart?r=' + Math.random(), {}, { params: cartQueryRequest });
};

export const getLiteSharedArtData = function (sharedArtRequest) {
  return get('/api/v1/PreConfig/SharedArts', {}, { params: sharedArtRequest });
};

export const getLiteMainItemData = function (parameter) {
  return get('/api/v1/PreConfig/BomOptions', {}, { params: parameter });
};
